import { Component, OnInit } from '@angular/core';
import { SettingsStateService } from './settings.state.service';
import { SettingsHttpService } from '../../../services/settings/settings.http.service';
import { StorageUtil } from '../../../utils/storage.util';
import { DashboardHttpUtil } from '../dashboard.util';
import { SettingsHttpUtil } from './settings.util';
import { AuthUtil } from '../../../utils/auth.utils';
import { environment } from '../../../../environments/environment';

@Component({
  moduleId: module.id,
  selector: 'bft-settings',
  templateUrl: 'settings.component.html',
  styleUrls: ['settings.component.css'],
  providers: []
})

export class SettingsComponent implements OnInit {

  display: boolean = false;
  required: boolean = false;
  displayRequiredEmailMessage: boolean = false;
  model = {
    email: '',
    debt: '',
    dueDate: '',
    claim: '',
    contractDate: '',
    message: '',
    obligation: '',
    phone: '',
    emailVal: '',
    phoneVal: '',
    dueDateVal: 0,
    contractDateVal: 0,
  };
  settings: any = {};

  constructor(
    private settingsStateService: SettingsStateService,
    private settingsHttpService: SettingsHttpService,
    private authUtil: AuthUtil
  ) {
    this.settings = environment;
    console.log(this.settings);
  }

  ngOnInit() {
    this.settingsStateService.handleSettingsStatus().subscribe(data => {
      this.getSettingsData(data);
    });
  }

  close($event): void {
    $event.preventDefault();
    if (this.model.email && !this.model.emailVal) {
      this.displayRequiredEmailMessage = true;
      return;
    }
    this.display = false;
  }

  closeErrorModal(): void {
    this.displayRequiredEmailMessage = false;
  }

  getSettingsData(setting) {
    const requestParams = DashboardHttpUtil.prepareTokenParam(StorageUtil.getToken());
    this.settingsHttpService.getSettings(requestParams).subscribe(
      success => {
        if (success) {
          if (success.json().response) {
            this.model = success.json().response;
            this.model['emailVal']   = this.model['emailVal'] || '';
            this.model['phoneVal']   = this.model['phoneVal'] || '';
            this.model['dueDateVal'] = this.model['dueDateVal'] || 0;
            this.model['contractDateVal'] = this.model['contractDateVal'] || 0;
            this.display = setting.display;
            this.required = setting.email;
          }

          this.authUtil.checkErrorResponse(success.json());
        }
      },
      error => {
      },
      () => {
      });
  }

  setSettingsAlert(key) {

    this.model[key] = !this.model[key];

    const data = {
      securityToken: StorageUtil.getToken(),
    };

    data[key] = +this.model[key];

    const requestParams = SettingsHttpUtil.prepareParamsSettings(data);
    this.settingsHttpService.setSettings(requestParams).subscribe(
      success => {
        if (success) {
            this.authUtil.checkErrorResponse(success.json());
        }
      },
      error => {
      },
      () => {
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/settings/settings.component.ts